export const RACE_ALIASES = {
	pacific: ['native hawaiian'],
	'native american': ['american indian', 'alaska native'],
	'hispanic/latino': ['hispanic or latino'],
	white: ['caucasian'],
	black: ['african'],
	asian: ['chinese', 'japanese'],
	other: ['others'],
}

export const RACE_STRINGS = {
	'multi-race': ['more than one race'],
	unknown: ['unknown/not reported']
}

export const RACES = ['asian', 'black', 'multi-race', 'hispanic/latino', 'pacific', 'native american', 'other', 'white', 'unknown']

const MALE_RE = /^(?:(?:gender|sex)[,:])?\s*male$/i
const FEMALE_RE = /^(?:(?:gender|sex)[,:])?\s*female$/i

export const matchAge = rowName => ['age'].includes(rowName)

export const matchMale = rowName => MALE_RE.test(rowName)
export const matchFemale = rowName => FEMALE_RE.test(rowName)

export const matchRace = race =>
	rowName => {
		if (!rowName)
			return false
		let parts = rowName.split(/[,:]\s*/) || []
		return RACE_STRINGS[race]?.some(s => rowName.includes(s)) ||
			(parts.includes('race') || parts.includes('race/ethnicity') || parts.includes('ethnicity')) &&
			parts.some(part => part.startsWith(race) || RACE_ALIASES[race]?.some(alias => part.indexOf(alias) > -1))
	}

export const MALE_SENSE_ID = 'SUVI3'
export const FEMALE_SENSE_ID = 'SUVEQ'
export const ELDERLY_SENSE_ID = 'SUcB'
export const INFANT_SENSE_ID = 'SUFMX'
export const CHILD_SENSE_ID = 'SUB98'
export const ADOLESCENCE_SENSE_ID = 'SUYr'
export const YOUNG_SENSE_ID = 'SUBRHQ'
export const YOUTH_SENSE_ID = 'SUVSL'
export const JUVENILE_SENSE_ID = 'SUMAHu'
export const CHILD_AND_TEENAGER_SENSE_ID = 'SUJAyD'
export const ADULT_SENSE_ID = 'SUaM'
export const AFRICAN_SENSE_ID = 'SUGuw'
export const AFRICAN_AMERICAN_SENSE_ID = 'SUU79'
export const WHITE_SENSE_ID = 'S2B0i'
export const ASIAN_SENSE_ID = 'SUTSN'
export const NATIVE_AMERICAN_SENSE_ID = 'SUFyGq'
export const ASIAN_PACIFIC_ISLANDER_SENSE_ID = 'SUF17V'
export const PACIFIC_ISLANDER_SENSE_ID = 'SGiP'
export const MIXED_RACE_SENSE_ID = 'SUCmhi'
export const DEMOGRAPHIC_IDS = [ MALE_SENSE_ID, FEMALE_SENSE_ID,
	ELDERLY_SENSE_ID, CHILD_SENSE_ID, ADULT_SENSE_ID, ADOLESCENCE_SENSE_ID, INFANT_SENSE_ID,
	YOUNG_SENSE_ID, YOUTH_SENSE_ID, JUVENILE_SENSE_ID, CHILD_AND_TEENAGER_SENSE_ID,
	AFRICAN_SENSE_ID, AFRICAN_AMERICAN_SENSE_ID, WHITE_SENSE_ID, ASIAN_SENSE_ID, NATIVE_AMERICAN_SENSE_ID,
	PACIFIC_ISLANDER_SENSE_ID, ASIAN_PACIFIC_ISLANDER_SENSE_ID, MIXED_RACE_SENSE_ID ]